(function () {
    'use strict';
    angular
        .module('laekkerAI.tablet')
        .component('takeJobQuestion', {
            controller: 'TakeJobQuestionController',
            templateUrl: '/components/take-job-question/take-job-question.html',
            bindings: {
                'resolve': '<',
                'close': '&'
            }
        });
})();